import { useMutation, useQueryClient } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';

export function useUnshareResource() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      resourceId,
      resourceType,
    }: {
      resourceId: string;
      resourceType: 'caso' | 'chat';
    }) => {
      const { data: userData } = await supabase.auth.getUser();
      if (!userData.user) throw new Error('Usuário não autenticado');

      if (resourceType === 'caso') {
        const { error } = await supabase
          .from('caso_user_shares')
          .delete()
          .eq('caso_id', resourceId)
          .eq('shared_by_user_id', userData.user.id);

        if (error) throw error;
      } else if (resourceType === 'chat') {
        const { error } = await supabase
          .from('conversation_user_shares')
          .delete()
          .eq('conversation_id', resourceId)
          .eq('shared_by_user_id', userData.user.id);

        if (error) throw error;
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['sharing-stats'] });
      queryClient.invalidateQueries({ queryKey: ['shared-resources'] });
      toast.success('Compartilhamento removido com sucesso');
    },
    onError: (error: any) => {
      console.error('Erro ao remover compartilhamento:', error);
      toast.error('Erro ao remover compartilhamento');
    },
  });
}
